import React from "react";
import { EmailShareButton, FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappShareButton } from "react-share";

import { copyToClipboard, getMobileOperatingSystem, trackMixpanel, useTranslation } from "utils";

import { Icon, Message as message } from "components";

export const SocialShareButtons = ({ color, text, url, onClick = () => {} }) => {
  const { t } = useTranslation("global");

  const handleCopyLink = async () => {
    copyToClipboard(url);
    message({ content: t("share.copiedToClipboard"), icon: "tick" });
  };

  return (
    <div
      onClick={onClick}
      className="social-share-buttons-container"
      style={{
        color: color,
      }}
    >
      {/* NOTE: onclick handler has problems with email share button for reasons */}
      <EmailShareButton body={text} separator={"\n\n"} url={url}>
        <Icon iconName="tabler/mail" className="icon inline" />
      </EmailShareButton>
      <WhatsappShareButton separator={"\n\n"} title={text} url={url} onClick={() => trackMixpanel("ClickShareButton", { type: "whatsapp" })}>
        <Icon iconName="tabler/brand-whatsapp" />
      </WhatsappShareButton>
      <FacebookShareButton quote={text} url={url} onClick={() => trackMixpanel("ClickShareButton", { type: "facebook" })}>
        <Icon iconName="tabler/brand-facebook" />
      </FacebookShareButton>
      <TwitterShareButton title={text} url={url} onClick={() => trackMixpanel("ClickShareButton", { type: "twitter" })}>
        <Icon iconName="tabler/brand-twitter" />
      </TwitterShareButton>
      <LinkedinShareButton title="Klim" summary={text} url={url} onClick={() => trackMixpanel("ClickShareButton", { type: "linkedin" })}>
        <Icon iconName="tabler/brand-linkedin" />
      </LinkedinShareButton>
      {!(getMobileOperatingSystem() !== "android") && <Icon iconName="tabler/link" style={{ cursor: "pointer" }} onClick={handleCopyLink} />}
    </div>
  );
};
